import logger from '3-foundation/Logging/logger';
import { mapContentCard } from './contentCardMapper';

interface Props {
	content: {
		contentType: 'contentCardList';
		properties: {
			heading: string;
			contentCards: {
				items: Content.ContentCard[];
			};
		};
	};
}

export const mapContentCardList = ({ content }: Props): Content.ContentCardList => {
	const settings = { properties: { orientation: 'Vertical', displayLinkAsButton: true } }; // ContentCard List has no settings and orientation is always Vertical
	try {
		return {
			documentType: 'contentCardList',
			content: {
				heading: content?.properties?.heading ?? null,
				contentCards: content?.properties?.contentCards?.items?.map((card) => mapContentCard({ content: card.content, settings })),
			},
		};
	} catch (e) {
		logger.error('Could not map ContentCardList', e);
		throw new Error('Could not map ContentCardList');
	}
};
